import { ChevronDownIcon, ChevronUpIcon } from '@persona-id/design-tokens/icons';
import styled from 'styled-components';

import { IconButton } from 'design-system/components/Button';
import { Paragraph } from 'design-system/components/Text';

const Container = styled.span`
  display: flex;
  align-items: center;
`;

const InstanceNumber = styled.span`
  display: inline-block;
  min-width: 15px;
  text-align: center;
`;

interface ExtractionToggleProps {
  index: number;
  numTotal: number;
  handleToggleDown: () => void;
  handleToggleUp: () => void;
}

const ExtractionToggle = ({
  index,
  numTotal,
  handleToggleDown,
  handleToggleUp,
}: ExtractionToggleProps) => {
  if (numTotal === 0) return null;
  if (numTotal === 1) return <Paragraph size='sm'>1 instance</Paragraph>;
  return (
    <Container>
      <IconButton
        id='docviewer__instance-toggle-up'
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleToggleUp();
        }}
      >
        <ChevronUpIcon />
      </IconButton>
      <Paragraph size='sm'>
        <InstanceNumber>{index}</InstanceNumber>
        out of
        <InstanceNumber>{numTotal}</InstanceNumber>
      </Paragraph>
      <IconButton
        id='docviewer__instance-toggle-down'
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleToggleDown();
        }}
      >
        <ChevronDownIcon />
      </IconButton>
    </Container>
  );
};

export default ExtractionToggle;
